<script setup lang="ts">
import { type LinkComponent, provideLink } from '../../composables/use-link';
import { provideLabels, type UiLabels } from '../../composables/use-labels';
import Toaster from '../toast/toaster.vue';
import OverlayProvider from '../modals/overlay/overlay-provider.vue';

type Props = {
  /**
   * The host router's link component (RouterLink, NuxtLink) for shared
   * components that render links.
   */
  link: LinkComponent;
  /**
   * Translations for the texts shared components render themselves (modal
   * actions, close buttons). Anything omitted falls back to English.
   */
  labels?: Partial<UiLabels>;
};

const props = defineProps<Props>();

provideLink(props.link);
provideLabels(() => props.labels ?? {});
</script>

<template>
  <slot />
  <OverlayProvider />
  <Toaster />
</template>
